
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle, ChevronDown, ChevronUp } from "lucide-react";

interface TestResultDisplayProps {
  result: any;
  error: string | null;
  showRawData: boolean;
  onToggleRawData: () => void;
  title: string;
}

export const TestResultDisplay = ({
  result,
  error,
  showRawData,
  onToggleRawData,
  title
}: TestResultDisplayProps) => {
  if (!result && !error) return null;

  return (
    <div className="mt-4">
      {result && (
        <>
          <div className="flex items-center justify-between">
            <h4 className="text-sm font-medium">{title}</h4>
            <Button 
              variant="ghost" 
              size="sm"
              onClick={onToggleRawData}
            >
              {showRawData ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
              {showRawData ? "Hide Raw Data" : "Show Raw Data"}
            </Button>
          </div>
          
          <div className="mt-2 p-3 bg-[#1a1a1a] rounded-md text-sm">
            {showRawData && (
              <pre className="mt-2 overflow-x-auto whitespace-pre-wrap">
                {JSON.stringify(result, null, 2)}
              </pre>
            )}
          </div>
        </>
      )}
      
      {error && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
    </div>
  );
};
